import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export default definePreset(Aura, {
  semantic: {
    primary: {
      50: '#D4DCF7',
      100: '#BFCAF3',
      200: '#94A7EB',
      300: '#6983E2',
      400: '#3E60DA',
      500: '#284CD1',
      600: '#2547C1',
      700: '#1D3796',
      800: '#14276B',
      900: '#0C1840',
      950: '#040815',
    },
  },
})
